// Data Service - Dependency Inversion Principle
// Abstract interface for data operations
class DataService {
  async getPosts(filters = {}) {
    throw new Error('getPosts method must be implemented');
  }

  async getPost(slug) {
    throw new Error('getPost method must be implemented');
  }

  async getCategories() {
    throw new Error('getCategories method must be implemented');
  }

  async getPostsByCategory(categorySlug) {
    throw new Error('getPostsByCategory method must be implemented');
  }

  async getFeaturedPosts() {
    throw new Error('getFeaturedPosts method must be implemented');
  }

  async getProfile() {
    throw new Error('getProfile method must be implemented');
  }
}

export default DataService;